<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2024-12-20 09:15:16
 * @LastEditors: 王赵坤
 * @LastEditTime: 2024-12-20 09:56:24
-->
<template>
  <div class="test_big">
    <el-result
      icon="warning"
      title="暂不支持移动端访问"
      subTitle="无法通过手机打开，请通过电脑访问"
    >
    </el-result>
  </div>
</template>

<script>
export default {
  name: "result",
  data() {
    return {};
  },
  methods: {
    // closeWindow() {
    //   var userAgent = navigator.userAgent;
    //   if (
    //     userAgent.indexOf("Firefox") !== -1 ||
    //     userAgent.indexOf("Chrome") !== -1
    //   ) {
    //     window.location.replace("about:blank");
    //   } else {
    //     window.opener = null;
    //     window.open("", "self");
    //     window.close();
    //   }
    // }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/Common/result.vue